export const errorMap = message => {
  if (/^Custom auth.*/i.test(message)) {
    return "Incorrect username or password.";
  }
  return message;
};
